import {
  lineClampMap,
  maxCharsWidthMap,
  textAlignmentMap,
  textColorMap,
  textSizeMap,
  textSizeMdMap,
  textWeightMap,
} from "@/constants/designSystemScale";
import {
  LineClampType,
  MaxCharsWidthType,
  TextAlignmentType,
  TextColorType,
  TextSizeMdType,
  TextSizeType,
  TextTagType,
  TextWeightType,
} from "@/types/designSystem.types";

interface TextProps {
  appearance?: TextColorType;
  size?: TextSizeType;
  sizeMd?: TextSizeMdType;
  weight?: TextWeightType;
  alignment?: TextAlignmentType;
  tag?: TextTagType;
  shadowClassName?: "selected-nav-item-text-shadow" | null;
  underline?: boolean;
  dangerouslyDisableDefaultTextColor?: boolean;
  children: React.ReactNode;
  lineClamp?: LineClampType;
  widthInChars?: MaxCharsWidthType;
  transition?: boolean;
  classNames?: string;
}

export function Text({
  appearance = "primary",
  size = 4,
  weight = "regular",
  alignment = "left",
  tag = "p",
  shadowClassName,
  sizeMd,
  underline = false,
  dangerouslyDisableDefaultTextColor = false, // try not to use this prop unless its extremely necessary
  lineClamp,
  widthInChars,
  classNames,
  transition = false,
  children,
}: TextProps) {
  const Tag = tag as keyof React.JSX.IntrinsicElements;

  const classes = `${transition ? "transition-all duration-200" : ""} ${textSizeMap[size].class} ${dangerouslyDisableDefaultTextColor ? "" : textColorMap[appearance].class} ${textWeightMap[weight].class} ${textAlignmentMap[alignment].class} ${underline ? "underline" : ""} ${sizeMd ? textSizeMdMap[sizeMd].class : ""} ${shadowClassName ? shadowClassName : ""} ${lineClamp ? lineClampMap[lineClamp].class : ""} ${widthInChars ? maxCharsWidthMap[widthInChars].class : ""} ${sizeMd ? textSizeMdMap[sizeMd].class : ""} ${classNames ? classNames : ""}`;

  return <Tag className={classes}>{children}</Tag>;
}
